import { XYChart } from '@amcharts/amcharts5/xy';
import React from 'react';

import { Dates } from 'context/DateProvider/DateProvider';
import { setSeries } from 'features/Health/components/MonetisationHealthChart/utils/setSeries';
import {
  formattingSettings,
  getXYChartSettings,
  xAxisRendererSettings,
  xAxisSettings,
  yAxisRendererSettings,
  yAxisSettings,
} from 'features/Health/components/MonetisationHealthChart/utils/settings';
import { HealthMetricsHistory } from 'features/Health/containers/MonetisationHealthChartContainer/types/healthMetrics';
import { am5Root, am5XYChart, dateAxis, valueAxis } from 'utils/charts/charts';
import { setAxisRenderer } from 'utils/charts/setAxisRenderer';
import { setCursor } from 'utils/charts/setCursor';
import { setCursorSelectBehaviour } from 'utils/charts/setCursorSelectBehaviour';
import { setFormatting } from 'utils/charts/setFormatting';
import { cursorSettingsWithEnabledSelect } from 'utils/charts/settings';

export const initialiseChart = (
  chartId: string,
  chartData: {
    demand: HealthMetricsHistory[];
    delivery: HealthMetricsHistory[];
  },
  minDateTimeRange: string,
  maxDateTimeRange: string,
  enableSelect: boolean,
  dateTimeRange?: Dates,
  setDateTimeRange?: React.Dispatch<React.SetStateAction<Dates>>
) => {
  const root = am5Root(chartId);
  setFormatting(root, formattingSettings);

  const chart: XYChart = root.container.children.push(am5XYChart(root, getXYChartSettings()));
  const xAxis = chart.xAxes.push(
    dateAxis(root, xAxisSettings(root, minDateTimeRange, maxDateTimeRange))
  );

  const yAxis = chart.yAxes.push(valueAxis(root, yAxisSettings(root)));

  const cursor = setCursor(root, chart, cursorSettingsWithEnabledSelect(enableSelect));
  setCursorSelectBehaviour(dateTimeRange, cursor, xAxis, setDateTimeRange);

  setAxisRenderer(yAxis, yAxisRendererSettings);
  setAxisRenderer(xAxis, xAxisRendererSettings);

  setSeries(root, chart, xAxis, yAxis, chartData);
  chart.appear(1000, 100);
  return root;
};
